import gql from 'graphql-tag';

export default gql`
fragment ProductImageAllData on ProductImage {
    id
    url
    mime_type
    size
    is_default
    conversions {
        thumbnail
        list
        full
    }
}
`;



// WEBPACK FOOTER //
// ./src/api/graphql/fragments/ProductImageAllData.ts